<div
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  class="flex items-center bg-gray-50 border rounded-xl transition-all focus-within:ring-2 focus-within:ring-brand/20 focus-within:border-brand"
  [class.border-red-400]="hasError()"
  [class.border-gray-200]="!hasError()"
>
  <button
    type="button"
    class="flex items-center gap-1.5 pl-3 pr-2 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-l-xl transition-colors cursor-pointer flex-shrink-0"
    [disabled]="isDisabled()"
    (click)="toggleDropdown(trigger)"
  >
    <span class="text-lg leading-none">{{ selectedCountry().flag }}</span>
    <span class="text-gray-600 text-sm font-semibold">{{ selectedCountry().dialCode }}</span>
    <svg
      class="w-3.5 h-3.5 text-gray-400 transition-transform duration-200"
      [class.rotate-180]="isOpen()"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>

  <div class="w-px h-6 bg-gray-200 flex-shrink-0"></div>

  <input
    #phoneInput
    type="tel"
    class="flex-1 min-w-0 px-3 py-2.5 bg-transparent outline-none font-medium text-sm"
    [placeholder]="selectedCountry().placeholder"
    [value]="localNumber()"
    [disabled]="isDisabled()"
    (input)="onInput($event)"
    (blur)="onBlur()"
    autocomplete="tel"
  />
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayWidth]="triggerWidth()"
  (backdropClick)="closeDropdown()"
  (detach)="closeDropdown()"
>
  <div class="bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden dropdown-enter">
    <div class="p-2 border-b border-gray-100">
      <div class="relative">
        <svg
          class="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <input
          #searchInput
          type="text"
          class="w-full pl-8 pr-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-lg outline-none focus:border-brand focus:ring-1 focus:ring-brand/20 transition-all"
          placeholder="Search countries..."
          [value]="searchQuery()"
          (input)="onSearchInput($event)"
        />
      </div>
    </div>
    <div class="max-h-52 overflow-y-auto overscroll-contain">
      @if (countrySections().preferred.length) {
        @for (country of countrySections().preferred; track country.code) {
          <button
            type="button"
            class="w-full flex items-center gap-2.5 px-3 py-2.5 text-sm hover:bg-gray-50 transition-colors cursor-pointer"
            [class.bg-brand/5]="country.code === selectedCountry().code"
            [class.font-semibold]="country.code === selectedCountry().code"
            (click)="selectCountry(country)"
          >
            <span class="text-base leading-none">{{ country.flag }}</span>
            <span class="flex-1 text-left text-gray-800 truncate">{{ country.name }}</span>
            <span class="text-gray-400 text-xs font-medium">{{ country.dialCode }}</span>
          </button>
        }
        <div class="border-t border-gray-100 my-1"></div>
      }
      @for (country of countrySections().other; track country.code) {
        <button
          type="button"
          class="w-full flex items-center gap-2.5 px-3 py-2.5 text-sm hover:bg-gray-50 transition-colors cursor-pointer"
          [class.bg-brand/5]="country.code === selectedCountry().code"
          [class.font-semibold]="country.code === selectedCountry().code"
          (click)="selectCountry(country)"
        >
          <span class="text-base leading-none">{{ country.flag }}</span>
          <span class="flex-1 text-left text-gray-800 truncate">{{ country.name }}</span>
          <span class="text-gray-400 text-xs font-medium">{{ country.dialCode }}</span>
        </button>
      }
      @if (!countrySections().preferred.length && !countrySections().other.length) {
        <div class="px-3 py-4 text-center text-sm text-gray-400">No countries found</div>
      }
    </div>
  </div>
</ng-template>
